module.exports = __webpack_public_path__ + "static/img/6106_phase_function_Paper_Points.1c1fd9e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/6106_phase_function_Paper_Points.png
// module id = uTeJ
// module chunks = 0